/* @flow */

import React, { useEffect } from 'react';

const OauthRedirect = (): React.Node => {
  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage(
        { type: 'oauth', action: 'oauth-redirect' },
        window.location.origin,
      );
    }
  }, []);

  return null;
};

export default OauthRedirect;
